import React, { useEffect, useMemo, useState } from "react";
import Map, { Marker, GeolocateControl } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { MAP_ACCESS_TOKEN, MAP_STYLE } from "./mapConfig";
import { translation } from "./Translation";
import NavigationPickerModal from "./NavigationPickerModal";
import {
  getNavigationLabel,
  parseMapCoordinates,
  requestNavigation,
} from "./navigationApps";

const CustomerMarker = () => (
  <svg
    width="32"
    height="36"
    viewBox="0 0 57 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M55.4409 21.4062C52.1597 6.96875 39.5659 0.46875 28.5034 0.46875C28.5034 0.46875 28.5034 0.46875 28.4722 0.46875C17.4409 0.46875 4.81585 6.9375 1.5346 21.375C-2.12165 37.5 7.75335 51.1562 16.6909 59.75C20.0034 62.9375 24.2534 64.5312 28.5034 64.5312C32.7534 64.5312 37.0034 62.9375 40.2847 59.75C49.2222 51.1562 59.0972 37.5312 55.4409 21.4062ZM28.5034 37.0625C23.0659 37.0625 18.6596 32.6562 18.6596 27.2188C18.6596 21.7813 23.0659 17.375 28.5034 17.375C33.9409 17.375 38.3472 21.7813 38.3472 27.2188C38.3472 32.6562 33.9409 37.0625 28.5034 37.0625Z"
      fill="#1AA3B9"
    />
  </svg>
);

const MapModal = ({ item }) => {
  const [lang] = useState(localStorage.getItem("lang") || "fa");
  const [userLocation, setUserLocation] = useState(null);
  const [showNavigationModal, setShowNavigationModal] = useState(false);
  const [viewState, setViewState] = useState({
    latitude: 35.6892,
    longitude: 51.389,
    zoom: 12,
  });

  const coords = useMemo(() => parseMapCoordinates(item), [item]);
  const label = useMemo(() => getNavigationLabel(item), [item]);

  useEffect(() => {
    if (!coords) {
      return;
    }

    setViewState({
      latitude: coords.lat,
      longitude: coords.lng,
      zoom: 15,
    });
  }, [coords]);

  useEffect(() => {
    if (!navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setUserLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      () => {},
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  }, []);

  const handleRoutingClick = () => {
    if (!coords) {
      return;
    }

    requestNavigation({
      lat: coords.lat,
      lng: coords.lng,
      label,
      onShowPicker: () => setShowNavigationModal(true),
    });
  };

  return (
    <div className="map-main">
      <NavigationPickerModal
        visible={showNavigationModal}
        onClose={() => setShowNavigationModal(false)}
        lat={coords?.lat}
        lng={coords?.lng}
        label={label}
        originLat={userLocation?.lat}
        originLng={userLocation?.lng}
      />

      <div className="map-modal home-map-modal shop-map-modal" id="map_modal">
        <div className="map-inner">
          <span className="title">
            {translation.Store_Map[lang] ? translation.Store_Map[lang] : "نقشه"}
          </span>
          {label ? <span className="shop-map-customer-name">{label}</span> : null}
          {item?.address ? (
            <span className="shop-map-customer-address">{item.address}</span>
          ) : null}

          <button type="button" onClick={handleRoutingClick} className="show-driver">
            {translation.Store_Routing[lang]
              ? translation.Store_Routing[lang]
              : "مسیریابی"}
          </button>

          <div className="map-g shop-map-frame">
            {coords ? (
              <Map
                {...viewState}
                onMove={(event) => setViewState(event.viewState)}
                mapboxAccessToken={MAP_ACCESS_TOKEN}
                mapStyle={MAP_STYLE}
                style={{ width: "100%", height: "100%" }}
                attributionControl={false}
              >
                <GeolocateControl position="top-left" />
                <Marker latitude={coords.lat} longitude={coords.lng} anchor="bottom">
                  <CustomerMarker />
                </Marker>
                {userLocation ? (
                  <Marker
                    latitude={userLocation.lat}
                    longitude={userLocation.lng}
                    anchor="center"
                  >
                    <span className="shop-map-user-dot" aria-hidden="true" />
                  </Marker>
                ) : null}
              </Map>
            ) : (
              <div className="shop-map-empty">موقعیت این مشتری ثبت نشده است.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapModal;
